module.exports = __webpack_public_path__ + "img/BCHSV.6717ade2.svg";